import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Footer from "../components/Footer";
import AnimatedPage from "../components/AnimatedPage";

function HistoryAll() {
    const [history, setHistory] = useState([]);
    const [profile, setProfile] = useState(JSON.parse(localStorage.getItem("profile")));
    const navigate = useNavigate();
    
    // State cho giao diện lọc
    const [activeTab, setActiveTab] = useState("ALL"); // ALL, PENDING, SUCCESS, DENY
    const [dateFilter, setDateFilter] = useState("today"); 
    const [typeFilter, setTypeFilter] = useState("all"); // all, vao, ra
    const [isLoading, setIsLoading] = useState(true);

    const handleBackClick = () => {
        navigate(-1);
    };

    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) {
                config.headers["Authorization"] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => Promise.reject(error)
    );

    useEffect(() => {
        setIsLoading(true);
        axios.get(`${process.env.REACT_APP_API_URL}/payment/chuyentien`, {})
            .then((res) => {
                if(res.data && res.data.data) {
                    setHistory(res.data.data);
                }
                setIsLoading(false);
            })
            .catch((err) => {
                setIsLoading(false);
            });

        axios.get(`${process.env.REACT_APP_API_URL}/auth/getUser`, {})
            .then((res) => {
                if (JSON.stringify(profile) !== JSON.stringify(res.data.data)) {
                    setProfile(res.data.data);
                    localStorage.setItem("profile", JSON.stringify(res.data.data));
                }
            })
            .catch((err) => localStorage.removeItem("user"));
    }, []);

    function formatDate(m) {
        const d = new Date(m);
        return d.getFullYear() + "-" + 
               ("0" + (d.getMonth() + 1)).slice(-2) + "-" + 
               ("0" + d.getDate()).slice(-2) + " " + 
               ("0" + d.getHours()).slice(-2) + ":" + 
               ("0" + d.getMinutes()).slice(-2);
    }

    // ============================================
    // LOGIC LỌC GIAO DỊCH CHUYỂN QUỸ
    // ============================================
    const now = new Date();
    const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime();
    const startOfYesterday = startOfToday - (24 * 60 * 60 * 1000);
    const startOf7DaysAgo = startOfToday - (6 * 24 * 60 * 60 * 1000);

    const filteredHistory = history?.filter(item => {
        // LỌC THEO LOẠI GIAO DỊCH TỪ DROPDOWN
        if (typeFilter === "vao" && item.type_payment !== "CHUYỂN QUỸ VÀO") return false;
        if (typeFilter === "ra" && item.type_payment !== "CHUYỂN QUỸ RA") return false;

        // Lọc theo Tab Trạng thái
        if (activeTab === "PENDING" && item.status_payment !== "Pending") return false;
        if (activeTab === "SUCCESS" && item.status_payment !== "Success") return false;
        if (activeTab === "DENY" && !["Deny", "lose", "Cancel", "cancelled"].includes(item.status_payment)) return false;
        
        // Lọc theo Thời gian
        const itemTime = new Date(item.createdAt).getTime();
        
        if (dateFilter === "today") {
            if (itemTime < startOfToday) return false;
        } else if (dateFilter === "yesterday") {
            if (itemTime < startOfYesterday || itemTime >= startOfToday) return false;
        } else if (dateFilter === "7days") {
            if (itemTime < startOf7DaysAgo) return false;
        }
        
        return true;
    }) || [];

    // Hàm Map Trạng thái
    const getStatusConfig = (status) => {
        if (status === "Pending") return { text: "Đang xử lý", className: "h-status-pending" };
        if (status === "Success") return { text: "Thành công", className: "h-status-success" };
        if (["Deny", "lose", "Cancel", "cancelled"].includes(status)) return { text: "Thất bại", className: "h-status-failed" };
        return { text: "Không rõ", className: "h-status-pending" };
    };

    // Icon Dropdown SVG
    const ChevronDown = () => (
        <svg viewBox="0 0 24 24" width="16" height="16" fill="#aaa"><path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"/></svg>
    );

    return (
        <div style={{ display: "flex", flexDirection: "column", height: "100vh", background: "#f5f7f9", overflow: "hidden" }}>
            
            <style dangerouslySetInnerHTML={{__html: `
                * { font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif; box-sizing: border-box; }
                body { background-color: #f5f7f9; margin: 0; padding: 0; color: #333; }
                
                .h-app-main {
                    position: fixed; top: 0; bottom: 60px; left: 0; right: 0; 
                    margin: 0 auto; max-width: 540px; background: #f9f9f9; 
                    display: flex; flex-direction: column; overflow-y: auto; overflow-x: hidden;
                    z-index: 10;
                }
                .h-app-main::-webkit-scrollbar { display: none; }
                .h-app-main { -ms-overflow-style: none; scrollbar-width: none; }

                /* HEADER */
                .h-header {
                    display: flex; align-items: center; justify-content: space-between;
                    height: 50px; padding: 0 15px; border-bottom: 1px solid #f0f0f0; background: #fff;
                    position: sticky; top: 0; z-index: 50;
                }
                .h-header-back { cursor: pointer; display: flex; align-items: center; justify-content: center; }
                .h-header-title { font-size: 16px; font-weight: 700; color: #333; flex: 1; text-align: center; margin-right: -24px;}
                
                /* TABS */
                .h-tabs {
                    display: flex; background: #fff; border-bottom: 1px solid #f0f0f0;
                }
                .h-tab {
                    flex: 1; text-align: center; padding: 14px 0; font-size: 13px; color: #888;
                    font-weight: 500; cursor: pointer; position: relative; transition: 0.2s;
                }
                .h-tab.active { color: #25aae1; font-weight: 600; }
                .h-tab.active::after {
                    content: ''; position: absolute; bottom: 0; left: 25%; right: 25%;
                    height: 3px; background: #25aae1; border-radius: 3px 3px 0 0;
                }

                /* BỘ LỌC */
                .h-filters {
                    display: flex; gap: 10px; padding: 15px; background: #f9f9f9;
                }
                .h-filter-sel-wrap {
                    flex: 1; position: relative; display: flex; align-items: center;
                    background: #fff; border: 1px solid #e0e0e0; border-radius: 6px;
                }
                .h-filter-sel-wrap select {
                    width: 100%; border: none; outline: none; background: transparent;
                    padding: 10px 30px 10px 12px; font-size: 13px; color: #555;
                    appearance: none; -webkit-appearance: none; cursor: pointer;
                }
                .h-filter-icon {
                    position: absolute; right: 10px; pointer-events: none; display: flex;
                }

                /* EMPTY STATE */
                .h-empty-state {
                    flex: 1; display: flex; flex-direction: column; align-items: center; justify-content: center;
                    padding-top: 60px;
                }
                .h-empty-state svg { width: 120px; height: auto; margin-bottom: 20px; }
                .h-empty-state span { font-size: 14px; color: #555; font-weight: 500; }

                /* DANH SÁCH ITEM */
                .h-list { 
                    padding: 0 15px 20px 15px; 
                    background: #fff; 
                    margin: 0 15px; 
                    border-radius: 10px;
                    box-shadow: 0 2px 8px rgba(0,0,0,0.04);
                }
                .h-item {
                    background: transparent; 
                    padding: 15px 0; 
                    border-bottom: 1px solid #eee;
                }
                .h-item:last-child {
                    border-bottom: none;
                }

                .h-item-row { display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px; }
                .h-item-title { font-size: 15px; font-weight: 600; color: #333; }
                .h-item-status { font-size: 12px; font-weight: 600; padding: 3px 8px; border-radius: 4px;}
                .h-status-pending { color: #f39c12; background: rgba(243, 156, 18, 0.1); }
                .h-status-success { color: #2ecc71; background: rgba(46, 204, 113, 0.1); }
                .h-status-failed { color: #e74c3c; background: rgba(231, 76, 60, 0.1); }
                .h-item-detail { font-size: 13px; color: #666; word-break: break-all; }
                .h-item-amount { font-size: 16px; font-weight: bold; }
                .h-item-date { font-size: 12px; color: #999; }
            `}} />

            <div className="h-app-main">
                <AnimatedPage>
                    {/* ===== HEADER ===== */}
                    <div className="h-header">
                        <div className="h-header-back" onClick={handleBackClick}>
                            <svg viewBox="0 0 24 24" width="24" height="24" fill="#333"><path d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"/></svg>
                        </div>
                        <div className="h-header-title">Lịch sử chuyển quỹ</div>
                        <div style={{ width: '24px' }}></div> 
                    </div>

                    {/* ===== TABS ===== */}
                    <div className="h-tabs">
                        <div className={`h-tab ${activeTab === "ALL" ? "active" : ""}`} onClick={() => setActiveTab("ALL")}>Toàn bộ</div>
                        <div className={`h-tab ${activeTab === "PENDING" ? "active" : ""}`} onClick={() => setActiveTab("PENDING")}>Đang chờ</div>
                        <div className={`h-tab ${activeTab === "SUCCESS" ? "active" : ""}`} onClick={() => setActiveTab("SUCCESS")}>Thành công</div>
                        <div className={`h-tab ${activeTab === "DENY" ? "active" : ""}`} onClick={() => setActiveTab("DENY")}>Thất bại</div>
                    </div>

                    {/* ===== FILTERS ===== */}
                    <div className="h-filters">
                        <div className="h-filter-sel-wrap">
                            <select value={dateFilter} onChange={(e) => setDateFilter(e.target.value)}>
                                <option value="today">Hôm nay</option>
                                <option value="yesterday">Hôm qua</option>
                                <option value="7days">7 ngày qua</option>
                                <option value="all">Tất cả</option>
                            </select>
                            <div className="h-filter-icon"><ChevronDown /></div>
                        </div>
                        <div className="h-filter-sel-wrap">
                            <select value={typeFilter} onChange={(e) => setTypeFilter(e.target.value)}>
                                <option value="all">Tất cả loại</option>
                                <option value="vao">Chuyển vào ví</option>
                                <option value="ra">Chuyển ra sảnh</option>
                            </select>
                            <div className="h-filter-icon"><ChevronDown /></div>
                        </div>
                    </div>

                    {/* ===== NỘI DUNG DANH SÁCH ===== */}
                    {isLoading ? (
                        <div style={{ textAlign: "center", padding: "50px", color: "#888", fontSize: "14px" }}>Đang tải dữ liệu...</div>
                    ) : filteredHistory.length === 0 ? (
                        <div className="h-empty-state">
                            <svg viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg">
                                <rect x="30" y="20" width="60" height="80" rx="8" fill="#e3f2fd" />
                                <rect x="40" y="40" width="40" height="6" rx="3" fill="#90caf9" />
                                <rect x="40" y="55" width="30" height="6" rx="3" fill="#90caf9" />
                                <rect x="40" y="70" width="20" height="6" rx="3" fill="#90caf9" />
                                <circle cx="70" cy="55" r="16" fill="#64b5f6" opacity="0.3" />
                                <path d="M85 35 L95 25 C97 23 100 23 102 25 L105 28 C107 30 107 33 105 35 L95 45 Z" fill="#25aae1" />
                                <path d="M85 35 L75 60 L80 62 L95 45 Z" fill="#4fc3f7" />
                                <path d="M75 60 L73 68 L78 65 Z" fill="#01579b" />
                                <path d="M75 65 Q 60 80 50 75" stroke="#25aae1" strokeWidth="2" fill="none" strokeLinecap="round" />
                            </svg>
                            <span>Không tìm thấy kết quả.</span>
                        </div>
                    ) : (
                        <div className="h-list">
                            {filteredHistory.map((item, key) => {
                                const statusConfig = getStatusConfig(item.status_payment);
                                const isVao = item.type_payment === "CHUYỂN QUỸ VÀO";
                                
                                let amountColor = "#666"; 
                                let prefix = "";
                                
                                if (item.status_payment === "Success") {
                                    amountColor = isVao ? "#2ecc71" : "#e74c3c"; 
                                    prefix = isVao ? "+" : "-";
                                } else if (item.status_payment === "Pending") {
                                    amountColor = isVao ? "#2ecc71" : "#e74c3c";
                                    prefix = isVao ? "" : "-"; 
                                }

                                return (
                                    <div className="h-item" key={key}>
                                        <div className="h-item-row">
                                            <div className="h-item-title">{item.type_payment}</div>
                                            <div className={`h-item-status ${statusConfig.className}`}>
                                                {statusConfig.text}
                                            </div>
                                        </div>
                                        
                                      <div className="h-item-row" style={{ marginTop: "10px", alignItems: "flex-end" }}>
                                            <div style={{ flex: 1, paddingRight: '10px', textAlign: 'left' }}>
                                                <div className="h-item-detail">{item.detail || "Giao dịch hệ thống"}</div>
                                                <div className="h-item-date" style={{ marginTop: "4px", textAlign: "left", display: "block" }}>
                                                    {formatDate(item.createdAt)}
                                                </div>
                                            </div>
                                            <div className="h-item-amount" style={{ color: amountColor, textAlign: 'right' }}>
                                                {prefix}{Number(item.money).toLocaleString('vi-VN')}₫
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    )}
                </AnimatedPage>
            </div>
            
        </div>
    );
}

export default HistoryAll;